import React from 'react';

import CircleTick from 'components/Icons/CircleTick';

import { IconListItemProps } from '../interfaces';
import {
  TextWrapper,
  Content,
  HiddenCheckbox,
  Wrapper,
  IconContainer,
  TickIndicator,
  Pill
} from './styled';

const IconListItem = React.forwardRef<HTMLInputElement, IconListItemProps>(function IconListItem(
  {
    icon,
    label,
    primaryColor,
    secondaryColor,
    subLabel,
    selected,
    id,
    disabled,
    value,
    name,
    onChange,
    selectionType,
    iconSize,
    inputProps,
    pillProps,
    iconContainerProps,
    contentProps,
    labelProps,
    subLabelProps,
    ...props
  },
  ref
) {
  return (
    <Wrapper {...props}>
      <HiddenCheckbox
        ref={ref}
        as='input'
        type={selectionType}
        value={value}
        id={id}
        name={name}
        disabled={disabled}
        onChange={onChange}
        checked={selected}
        {...inputProps}
      />
      <Pill
        htmlFor={id}
        selected={selected}
        borderColor={primaryColor}
        backgroundColor={secondaryColor}
        {...pillProps}>
        {!!selected && (
          <TickIndicator>
            <CircleTick fill={primaryColor} />
          </TickIndicator>
        )}
        <IconContainer iconSize={iconSize} {...iconContainerProps}>
          {icon}
        </IconContainer>
        <Content {...contentProps}>
          <TextWrapper type='heading' {...labelProps}>
            {label}
          </TextWrapper>
          {subLabel && (
            <TextWrapper type='sub' {...subLabelProps}>
              {subLabel}
            </TextWrapper>
          )}
        </Content>
      </Pill>
    </Wrapper>
  );
});

export default IconListItem;
